import React, { useEffect, useState } from "react";
import {  useNavigate } from "react-router-dom";
import { auth, db } from "../../Admin/Config/Config";
import { addDoc, collection, doc, getDocs, updateDoc } from "firebase/firestore";
import { useToast } from "../../Toast.jsx/Toast";

export default function BillingAddress() {
  const [addresses, setAddresses] = useState([]);
  const [address, setaddress] = useState({email: auth.currentUser.email, country:"Canada", state:"Ontario", city: "", unit_number: "", street: "", zip: ""});
  const {showSuccess} = useToast();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleCountryChange = (e) => {
    const countryName = e.target.value;
    setaddress({...address, country: countryName});
  };

  useEffect(() => {
    fetchAddress();
  }, []);

 const fetchAddress = async () => {
   const ref = collection(db, "users", auth.currentUser.uid, "address");
   const querySnapshot = await getDocs(ref);
   const add = [];

   querySnapshot.forEach((doc) => {
     add.push({ id: doc.id, ...doc.data() });
   });

   setAddresses(add);

  
   if (add.length > 0) {
     setaddress(add[0]); 
   }
 };

  const [selectedAddress, setSelectedAddress] = useState(null);
  const [isNewAddress, setIsNewAddress] = useState(true);
  const handleAddressChange = (e) => {
    const selected = addresses.find(
      (address) => address.id === e.target.value
    );
    if (selected) {
      setSelectedAddress(e.target.value);
      setaddress(selected);
    }
  };

  const handleNewAddressToggle = () => {
    setIsNewAddress(!isNewAddress);
    if (isNewAddress) {
      setSelectedAddress("");
      setaddress({email: auth.currentUser.email,
        mobile:"",
        name: "",
        city: "",
        unit_number: "",
        street: "",
        zip: "",
        country:"",
        state:""});
    }
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    setLoading(true);
    if(!selectedAddress){
      await addDoc(
        collection(db, "users", auth.currentUser.uid, "address"),
        address
      );
      await updateDoc(
        doc(db, "users", auth.currentUser.uid),
        {
          mobile: address.mobile,
        }
      );
      setLoading(false);
      navigate("/checkout", {
        state: {
          address: address,
       
        },
      });
    } else {
      navigate("/checkout", {
        state: {
          address: address,
        },
      });
    }
  };

  const formatAddress = (address) => {
    const { name, street, city, state, zip, country } = address;
    return `${name ? name + ", " : ""}${street ? street + ", " : ""}${
      city ? city + ", " : ""
    }${state ? state + ", " : ""}${zip ? zip + ", " : ""}${
      country ? country : ""
    }`.trim();
  };

  const onAddressSave = () => {
    if(selectedAddress){
      const ref = doc(
        db,
        "users",
        auth.currentUser.uid,
        "address",
        selectedAddress
      );
      updateDoc(ref, address);
      fetchAddress();
      showSuccess("Address updated successfully");
    } else {
      const ref = collection(
        db,
        "users",
        auth.currentUser.uid,
        "address",
      );
      addDoc(ref,address)
      showSuccess("Address updated successfully");
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-gray-50 to-slate-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Header Section */}

        {/* Main Form Container */}
        <div className="bg-white rounded-3xl  border border-gray-100 overflow-hidden">
          {/* Form Header */}
          <div className="bg-gradient-to-r from-red-500 via-red-600 to-red-700 px-4 py-3 sm:px-6 sm:py-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <div className="w-6 h-6 sm:w-8 sm:h-8 bg-white/20 rounded-full flex items-center justify-center">
                  <svg
                    className="w-3 h-3 sm:w-4 sm:h-4 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                </div>
                <div>
                  <h2 className="text-lg sm:text-xl font-semibold text-white">
                    Personal Information
                  </h2>
                  <p className="text-red-100 text-xs sm:text-sm">
                    Please provide your contact details
                  </p>
                </div>
                {/* <button className="inline-flex items-center justify-center px-3 py-1.5 text-xs font-medium text-white bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 transition-all duration-200 rounded-lg shadow-md">
                  Change address
                </button> */}
                <button
                  type="button"
                  onClick={handleNewAddressToggle}
                  className="inline-flex items-center px-4 py-2 text-xs sm:text-sm font-medium text-red-600 hover:text-red-700 transition-colors duration-200 bg-red-50 hover:bg-red-100 rounded-xl"
                >
                  <svg
                    className="w-3 h-3 mr-1.5 sm:w-4 sm:h-4 sm:mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                    />
                  </svg>
                  Choose from existing addresses
                </button>
              </div>

              <div className="hidden sm:block">
                <div className="w-2 h-2 bg-white/30 rounded-full"></div>
              </div>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="p-4 sm:p-6">
            {/* Address Selection Section */}
            {isNewAddress ? (
            <></>
            ) : (
              <div className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-2xl p-4 mb-4">
                <div className="flex items-center mb-3">
                  <div className="w-5 h-5 bg-red-500 rounded-full flex items-center justify-center mr-2">
                    <svg
                      className="w-2.5 h-2.5 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <h4 className="text-sm sm:text-base font-semibold text-gray-900">
                    Saved Addresses
                  </h4>
                </div>

                <div className="mb-3">
                  <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">
                    Choose Address:
                  </label>
                  <select
                    value={selectedAddress}
                    onChange={handleAddressChange}
                    className="w-full px-3 py-2 sm:px-4 sm:py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-red-100 focus:border-red-500 transition-all duration-300 bg-white appearance-none text-sm"
                  >
                    <option value="" disabled>
                      Select an address
                    </option>
                    {addresses &&
                      addresses.map((add) => (
                        <option key={add.id} value={add.id}>
                          {formatAddress(add)}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="flex justify-between items-center space-x-2">
                  <button
                    type="button"
                    onClick={handleNewAddressToggle}
                    className="inline-flex items-center justify-center px-3 py-1.5 text-xs font-medium text-red-600 hover:text-red-700 transition-colors duration-200 bg-white hover:bg-red-50 rounded-lg border border-red-200"
                  >
                    <svg
                      className="w-3 h-3 mr-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                      />
                    </svg>
                    New Address
                  </button>
                  {!isNewAddress && selectedAddress && (
                    <button
                      type="button"
                      onClick={onAddressSave}
                      className="inline-flex items-center justify-center px-3 py-1.5 text-xs font-medium text-white bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 transition-all duration-200 rounded-lg shadow-md"
                    >
                      <svg
                        className="w-3 h-3 mr-1"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                      Save
                    </button>
                  )}
                </div>
              </div>
            )}
            {/* Personal Information Section */}
            <div className="mb-6">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {/* Full Name */}
                <div className="lg:col-span-2">
                  <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">
                    Full Name <span className="text-red-500">*</span>
                  </label>
                  <div className="relative group">
                    <input
                      type="text"
                      placeholder="Enter your full name"
                      value={address.name}
                      onChange={(e) =>
                        setaddress({ ...address, name: e.target.value })
                      }
                      className="w-full px-3 py-2 sm:px-4 sm:py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-red-100 focus:border-red-500 transition-all duration-300 bg-gray-50 hover:bg-white group-hover:border-gray-300 text-sm"
                      required
                    />
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                      <svg
                        className="h-4 w-4 text-gray-400 group-hover:text-gray-500 transition-colors"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                {/* Mobile Number */}
                <div className="lg:col-span-2">
                  <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">
                    Mobile Number <span className="text-red-500">*</span>
                  </label>
                  <div className="relative group">
                    <div className="flex">
                      <div className="px-3 py-2 sm:px-4 sm:py-3 bg-gradient-to-r from-red-500 to-red-600 text-white border-2 border-red-500 rounded-l-xl font-medium flex items-center text-sm">
                        <svg
                          className="w-3 h-3 mr-1 sm:w-4 sm:h-4 sm:mr-2"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                          />
                        </svg>
                        +1
                      </div>
                      <input
                        type="tel"
                        placeholder="Enter your mobile number"
                        value={address.mobile}
                        onChange={(e) =>
                          setaddress({ ...address, mobile: e.target.value })
                        }
                        className="flex-1 px-3 py-2 sm:px-4 sm:py-3 border-2 border-l-0 border-gray-200 rounded-r-xl focus:ring-2 focus:ring-red-100 focus:border-red-500 transition-all duration-300 bg-gray-50 hover:bg-white group-hover:border-gray-300 text-sm"
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Address Information Section */}
            <div className="mb-6">
              <div className="flex items-center mb-4">
                <div className="w-6 h-6 bg-gradient-to-r from-red-500 to-red-600 rounded-full flex items-center justify-center mr-2">
                  <svg
                    className="w-3 h-3 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                    />
                  </svg>
                </div>
                <h3 className="text-base sm:text-lg font-semibold text-gray-900">
                  Address Information
                </h3>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Street Address */}
                <div className="md:col-span-2">
                  <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">
                    Street Address<span className="text-red-500">*</span>
                  </label>
                  <div className="relative group">
                    <input
                      type="text"
                      placeholder="Enter street address"
                      value={address.street}
                      onChange={(e) =>
                        setaddress({ ...address, street: e.target.value })
                      }
                      required
                      className="w-full px-3 py-2 sm:px-4 sm:py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-red-100 focus:border-red-500 transition-all duration-300 bg-gray-50 hover:bg-white group-hover:border-gray-300 text-sm"
                    />
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                      <svg
                        className="h-4 w-4 text-gray-400 group-hover:text-gray-500 transition-colors"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                {/* City */}
                <div>
                  <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">
                    City
                  </label>
                  <div className="relative group">
                    <input
                      type="text"
                      placeholder="Enter city"
                      value={address.city}
                      onChange={(e) =>
                        setaddress({ ...address, city: e.target.value })
                      }
                      className="w-full px-3 py-2 sm:px-4 sm:py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-red-100 focus:border-red-500 transition-all duration-300 bg-gray-50 hover:bg-white group-hover:border-gray-300 text-sm"
                    />
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                      <svg
                        className="h-4 w-4 text-gray-400 group-hover:text-gray-500 transition-colors"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                {/* Unit Number */}
                <div>
                  <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">
                    Unit Number
                  </label>
                  <div className="relative group">
                    <input
                      type="text"
                      placeholder="Enter unit number"
                      value={address.unit_number}
                      onChange={(e) =>
                        setaddress({ ...address, unit_number: e.target.value })
                      }
                      className="w-full px-3 py-2 sm:px-4 sm:py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-red-100 focus:border-red-500 transition-all duration-300 bg-gray-50 hover:bg-white group-hover:border-gray-300 text-sm"
                    />
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                      <svg
                        className="h-4 w-4 text-gray-400 group-hover:text-gray-500 transition-colors"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                {/* Zip Code */}
                <div>
                  <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">
                    Zip Code <span className="text-red-500">*</span>
                  </label>
                  <div className="relative group">
                    <input
                      type="text"
                      placeholder="Enter zip code"
                      value={address.zip}
                      onChange={(e) =>
                        setaddress({ ...address, zip: e.target.value })
                      }
                      required
                      className="w-full px-3 py-2 sm:px-4 sm:py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-red-100 focus:border-red-500 transition-all duration-300 bg-gray-50 hover:bg-white group-hover:border-gray-300 text-sm"
                    />
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                      <svg
                        className="h-4 w-4 text-gray-400 group-hover:text-gray-500 transition-colors"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                {/* Country */}
                <div>
                  <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">
                    Country <span className="text-red-500">*</span>
                  </label>
                  <div className="relative group">
                    <select
                      value={address.country}
                      onChange={handleCountryChange}
                      required
                      className="w-full px-3 py-2 sm:px-4 sm:py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-red-100 focus:border-red-500 transition-all duration-300 bg-gray-50 hover:bg-white group-hover:border-gray-300 appearance-none text-sm"
                    >
                      <option value={"Canada"}>Canada</option>
                    </select>
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                      <svg
                        className="h-4 w-4 text-gray-400 group-hover:text-gray-500 transition-colors"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                {/* State */}
                <div>
                  <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">
                    State <span className="text-red-500">*</span>
                  </label>
                  <div className="relative group">
                    <select
                      value={address.state}
                      required
                      onChange={(e) =>
                        setaddress({ ...address, state: e.target.value })
                      }
                      className="w-full px-3 py-2 sm:px-4 sm:py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-red-100 focus:border-red-500 transition-all duration-300 bg-gray-50 hover:bg-white group-hover:border-gray-300 appearance-none text-sm"
                    >
                      <option key={address.id} value={`Ontario`}>
                        {`Ontario`}
                      </option>
                    </select>
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                      <svg
                        className="h-4 w-4 text-gray-400 group-hover:text-gray-500 transition-colors"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="pt-4 flex justify-end space-x-4">
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="px-6 py-2 sm:px-8 sm:py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium text-xs sm:text-sm rounded-lg sm:rounded-xl shadow-md transition-all duration-300 transform hover:scale-[1.01] flex items-center justify-center min-w-[120px]"
              >
                <svg
                  className="mr-1.5 w-3 h-3 sm:w-4 sm:h-4"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                Back
              </button>

              <button
                type="submit"
                className="px-6 py-2 sm:px-8 sm:py-3 bg-gradient-to-r from-red-500 via-red-600 to-red-700 hover:from-red-600 hover:via-red-700 hover:to-red-800 text-white font-medium text-xs sm:text-sm rounded-lg sm:rounded-xl shadow-md transition-all duration-300 transform hover:scale-[1.01] flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed min-w-[180px]"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <svg
                      className="animate-spin -ml-1 mr-1.5 h-3 w-3 sm:h-4 sm:w-4 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Processing...
                  </>
                ) : (
                  <>
                    Continue to Checkout
                    <svg
                      className="ml-1.5 -mr-1 w-3 h-3 sm:w-4 sm:h-4"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}